module.exports = __webpack_public_path__ + "95c96c96d1e56a77ea549d68de12effa.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame_staff.png
// module id = 185
// module chunks = 0